import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import ButtonGroup from '../ReduxFormFields/ButtonGroup';
import { Field, getFormValues } from 'redux-form';
import { Box, HorizontalFormControl } from '../../../../../../common/components';
import { Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';

export class Account extends Component {
  render() {
    const { content } = this.props;
    return (
      <Box>
        <Row>
          <Col sm={12}>
            <h4 className="page-title">Account Information</h4>
            <hr />
          </Col>
        </Row>

        {content.fields.map((field) => {
          switch (field.type) {
            case 'currency': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={9}
                  fieldSize={3}
                  currency
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'free_type_percentage': {
              return (
                <Field
                  component={HorizontalFormControl}
                  name={field.name}
                  key={field.name}
                  label={field.label}
                  labelSize={9}
                  fieldSize={3}
                  percentage
                />
              );
            }
            case 'input': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={9}
                  fieldSize={3}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'question': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={9}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={3}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={field.name}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              );
            }

            case 'inputArray': {
              return (
                <div key={field.name}>
                  <FormGroup>
                    <Col sm={12}>
                      <ControlLabel>
                        Please name the three main non-life companies with whom you have
                        agencies i.e. your largest accounts:
                      </ControlLabel>
                    </Col>
                  </FormGroup>
                  {[...Array(field.numberOfInputs).keys()].map((a) => {
                    return (
                      <Field
                        name={`${field.name}[${a}]`}
                        key={a}
                        labelSize={1}
                        fieldSize={7}
                        component={HorizontalFormControl}
                        label={a + 1}
                      />
                    );
                  })}
                </div>
              );
            }
          }
        })}
      </Box>
    );
  }
}

export default connect((state, props) => {
  return {
    formValues: getFormValues(props.form)(state),
  };
})(Account);
